import { View } from 'react-native';

import { cn } from '@/components/ui/cn';
import { SectionMarker } from '@/components/ui/SectionMarker';
import { Text } from '@/components/ui/Text';

export interface LegalSectionProps {
  /** Two-digit marker, e.g. "01". */
  index: string;
  label: string;
  body: string;
  className?: string;
}

/** A numbered Terms / Privacy clause under a mono marker. */
export function LegalSection({ index, label, body, className }: LegalSectionProps) {
  return (
    <View className={cn('gap-2', className)}>
      <SectionMarker index={index} label={label} />
      <Text variant="body" className="text-foreground-secondary">
        {body}
      </Text>
    </View>
  );
}
